import { FC, memo } from 'react';
import styled from 'styled-components';

import ShowsTabContent from '@components/searchTab/ShowsTabContent';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const Search: FC = () => {
  return (
    <Container>
      <ShowsTabContent />
    </Container>
  );
};

export default memo(Search);
